import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getApiUrl } from '../../config/demoMode';
import HataSayfasi, { HataButon } from '../hata/HataSayfasi';
import { IkonSaat, IkonZarf } from '../../components/Ikonlar';

const API_URL = getApiUrl();

export default function DemoSuresiDoldu() {
  const { logoutUser } = useAuth();
  const navigate = useNavigate();

  const handleCikis = async () => {
    try {
      if (API_URL) await fetch(`${API_URL}/Auth/logout`, { method: 'POST', credentials: 'include' });
    } catch {}
    logoutUser();
    navigate('/login');
  };

  return (
    <HataSayfasi
      renk="amber"
      ikon={<IkonSaat size={40} />}
      baslik="Demo Süresi Doldu"
      aciklama={<>Deneme süreniz sona erdi. Paneli kullanmaya devam etmek için bizimle iletişime geçin.</>}
      altYazi="Demo ortamındaki veriler canlı otel verilerinden ayrıdır; deneme süresi bittiğinde kayıtlarınız silinmez."
      aksiyonlar={<HataButon birincil onClick={handleCikis}>Giriş Sayfasına Dön</HataButon>}
    >
      <div className="bg-white border-2 border-gray-100 rounded-2xl px-5 py-4 mt-6 text-left">
        <p className="text-[10px] font-black uppercase tracking-widest text-gray-400 mb-2.5">İletişim</p>
        <a href="mailto:info@hotelflow.com.tr"
           className="flex items-center gap-2.5 text-sm font-bold text-gray-700 hover:text-violet-600 transition-colors">
          <span className="text-gray-300"><IkonZarf /></span>
          info@hotelflow.com.tr
        </a>
      </div>
    </HataSayfasi>
  );
}
